<div id="main-div" class="main-div">
    <table mat-table matSort class="table-div" [dataSource]="dataSource" (matSortChange)="handleSortChange($event)">
        <ng-container matColumnDef="nsContactName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="nsContactName">NetSuite Contact Name</th>
            <td
                mat-cell
                *matCellDef="let element"
                class="actionable-item"
                (click)="handleUserSelected(element)"
                appHighlight
                [searchedWords]="searchText"
                [text]="element.nsContactName"
                [ignoreCase]="true"
                classToApply="selected"
            >
                {{ element.nsContactName }}
            </td>
        </ng-container>

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="email">Email</th>
            <td
                mat-cell
                *matCellDef="let element"
                class="actionable-item"
                (click)="handleUserSelected(element)"
                appHighlight
                [searchedWords]="searchText"
                [text]="element.email"
                [ignoreCase]="true"
                classToApply="selected"
            >
                {{ element.email }}
            </td>
        </ng-container>

        <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="firstName">First Name</th>
            <td mat-cell *matCellDef="let element">
                <span
                    class="actionable-item"
                    (click)="handleUserSelected(element)"
                    appHighlight
                    [searchedWords]="searchText"
                    [text]="element.firstName"
                    [ignoreCase]="true"
                    classToApply="selected"
                    >{{ element.firstName }}</span
                >
            </td>
        </ng-container>

        <ng-container matColumnDef="middleName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="middleName">Middle Name</th>
            <td mat-cell *matCellDef="let element">
                <span
                    class="actionable-item"
                    (click)="handleUserSelected(element)"
                    appHighlight
                    [searchedWords]="searchText"
                    [text]="element.middleName"
                    [ignoreCase]="true"
                    classToApply="selected"
                    >{{ element.middleName }}</span
                >
            </td>
        </ng-container>

        <ng-container matColumnDef="lastName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="lastName">Last Name</th>
            <td mat-cell *matCellDef="let element">
                <span
                    class="actionable-item"
                    (click)="handleUserSelected(element)"
                    appHighlight
                    [searchedWords]="searchText"
                    [text]="element.lastName"
                    [ignoreCase]="true"
                    classToApply="selected"
                    >{{ element.lastName }}</span
                >
            </td>
        </ng-container>

        <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="role">Role</th>
            <td
                mat-cell
                *matCellDef="let element"
                appHighlight
                [searchedWords]="searchText"
                [text]="element.role"
                [ignoreCase]="true"
                classToApply="selected"
            >
                {{ element.role }}
            </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="status">Login Status</th>
            <!-- Do not use appHighlight here as it removes the styling around the text -->
            <td mat-cell *matCellDef="let element">
                <div class="auth0-div">
                    <app-tooltip [tooltip]="getLoginStatusTooltip(element)">
                        <app-chip
                            *ngIf="element.id && element.auth0Id"
                            [chipClass]="getLoginDisplayStatus(element).toLowerCase()"
                            [label]="getLoginDisplayStatus(element)"
                        ></app-chip>
                    </app-tooltip>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="products">
            <th mat-header-cell *matHeaderCellDef>Applications</th>
            <td mat-cell *matCellDef="let element">
                <div class="products-div">
                    <div class="chips-div">
                        <span *ngFor="let application of element.applications" class="chip">
                            <app-tooltip width="120px" [tooltip]="application.name">
                                <app-chip [label]="application.abbr"></app-chip>
                            </app-tooltip>
                        </span>
                    </div>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element; index as idx">
                <div
                    class="action-cell"
                    [class.action-cell-clicked]="idx === selectedIndex"
                    [matMenuTriggerFor]="menu"
                    aria-label="User action menu"
                    (click)="openMenu($event, idx)"
                    (menuClosed)="handleMenuClosedEvent($event, idx)"
                >
                    <div class="action-div">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </div>
                </div>
                <mat-menu #menu="matMenu" xPosition="before" yPosition="below">
                    <div
                        *ngIf="canEditUser(element.status)"
                        mat-menu-item
                        class="menu-option"
                        (click)="handleEditUserClick(element)"
                    >
                        Edit User
                    </div>
                    <div
                        *ngIf="canViewUserActivity(element.status)"
                        mat-menu-item
                        class="menu-option"
                        (click)="handleUserActivityClick(idx)"
                    >
                        User Activity
                    </div>
<!--                    <div-->
<!--                        *ngIf="canResendInvitation(element.status)"-->
<!--                        mat-menu-item-->
<!--                        class="menu-option"-->
<!--                        (click)="handleResendInvitation(idx)"-->
<!--                    >-->
<!--                        Resend Invitation-->
<!--                    </div>-->
<!--                    <div-->
<!--                        *ngIf="showRevokeAccess"-->
<!--                        mat-menu-item-->
<!--                        class="menu-option menu-option-red"-->
<!--                        (click)="handleRevokeAccessClick(element)"-->
<!--                    >-->
<!--                        Revoke Access-->
<!--                    </div>-->
                    <div
                        *ngIf="element.id"
                        mat-menu-item
                        class="menu-option"
                        (click)="handleImpersonateUser(element.id)"
                    >
                        Impersonate User in Shareholder Portal
                    </div>
                </mat-menu>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: !showCreateUser"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="intadm-table-row"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell no-data" colspan="10"><span *ngIf="!fetching">No data</span></td>
        </tr>
    </table>
</div>
<div class="paginator-div">
    <mat-paginator
        [length]="totalRecords"
        [pageIndex]="page"
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 25, 50, 100]"
        aria-label="Select page"
        showFirstLastButtons="true"
        disabled="false"
        hidePageSize="false"
        (page)="handlePageEvent($event)"
    >
    </mat-paginator>
</div>
